
import '../assets/scss/style.scss';
import { defineComponent } from "@vue/runtime-core";
import { ref } from 'vue';

export default defineComponent({
    name: "PingComingSoonPage",
    data() {
        const email = ref("");
        const isEmailValid = ref(true);
        const onSubmit = (e: any) => {
            e.preventDefault();
            isEmailValid.value = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.value);
            if (isEmailValid.value) {
                alert("Thank you for subscribing.");
                email.value = "";
            }
        };
        return {
            email,
            isEmailValid,
            onSubmit
        }
    }
})
